// WHY: силуэты лежат файлами в public/ghosts, а не строками в бандле — словарь base64 весил ~150 КБ в JS каждой страницы
export const GHOST_KEYS: ReadonlySet<string> = new Set([
  'agent',
  'ak-47',
  'aug',
  'awp',
  'bayonet',
  'bloodhound-gloves',
  'bowie-knife',
  'broken-fang-gloves',
  'butterfly-knife',
  'capsule',
  'case',
  'charm',
  'classic-knife',
  'cz75-auto',
  'default',
  'desert-eagle',
  'driver-gloves',
  'dual-berettas',
  'falchion-knife',
  'famas',
  'five-seven',
  'flip-knife',
  'g3sg1',
  'galil-ar',
  'glock-18',
  'graffiti',
  'gut-knife',
  'hand-wraps',
  'huntsman-knife',
  'hydra-gloves',
  'karambit',
  'kukri-knife',
  'm249',
  'm4a1-s',
  'm4a4',
  'm9-bayonet',
  'mac-10',
  'mag-7',
  'moto-gloves',
  'mp5-sd',
  'mp7',
  'mp9',
  'music-kit',
  'navaja-knife',
  'negev',
  'nomad-knife',
  'nova',
  'p2000',
  'p250',
  'p90',
  'paracord-knife',
  'patch',
  'pp-bizon',
  'r8-revolver',
  'sawed-off',
  'scar-20',
  'sg-553',
  'shadow-daggers',
  'skeleton-knife',
  'specialist-gloves',
  'sport-gloves',
  'ssg-08',
  'sticker',
  'stiletto-knife',
  'survival-knife',
  'talon-knife',
  'tec-9',
  'ump-45',
  'ursus-knife',
  'usp-s',
  'xm1014',
  'zeus-x27',
]);
